import type { FireOperationalEvent } from '../../../common/types/new-avp-experience/analytics';
import type {
	GetPreferencesAPIResponse,
	UpdatePreferencesAPIResponse,
} from '../../../common/types/new-avp-experience/api-responses';
import type { WorkspaceId } from '../../../common/types/new-avp-experience/workspace';
import { performReportsGetRequest, performReportsPutRequest } from '../../utils/fetch';
import { getPreferencesUrl, updatePreferencesUrl } from '../utils/reporting-urls';

export const getPreferences = async (
	workspaceId: WorkspaceId,
	featureGateKey: string,
	fireOperationalEvent: FireOperationalEvent,
) => {
	try {
		return await performReportsGetRequest<GetPreferencesAPIResponse>(
			getPreferencesUrl(workspaceId, featureGateKey),
			undefined,
			{
				analyticsPayload: {
					actionSubject: 'preferencesRequest',
				},
				fireOperationalEvent,
			},
		);
	} catch (error) {
		throw new Error(`[Preferences API] Failed to get preferences: ${error}`);
	}
};

export const updatePreferences = async (
	workspaceId: WorkspaceId,
	featureGateKey: string,
	value: boolean,
	fireOperationalEvent: FireOperationalEvent,
) => {
	try {
		return await performReportsPutRequest<UpdatePreferencesAPIResponse>(
			updatePreferencesUrl(workspaceId, featureGateKey),
			{
				selectedValue: value,
			},
			undefined,
			{
				analyticsPayload: {
					actionSubject: 'preferencesUpdate',
				},
				fireOperationalEvent,
			},
		);
	} catch (error) {
		throw new Error(`[Preferences API] Failed to update preferences: ${error}`);
	}
};
